import { observer } from 'mobx-react-lite';

import { TReportTemplate } from '../../core/report';
import { ReportTemplateForm } from '../report-template-form';

type FormFields = { name: string; file?: any };

type DetailsReportTemplateProps = {
  reportTemplate: TReportTemplate;
  onUpdated: (fields: FormFields) => void;
};

export const DetailsReportTemplate = observer(
  ({ reportTemplate, onUpdated }: DetailsReportTemplateProps) => {
    return (
      <ReportTemplateForm
        reportId={reportTemplate.id}
        value={reportTemplate}
        fileRequired={false}
        onSubmit={onUpdated}
      />
    );
  },
);
